import $ from 'jquery';
window.jQuery = $;
function scaleSubscriptionBlock() {
    //calculate scale
    let nCurrenScale; // scale tracking var
    let nNewScale = jQuery(".subscription-block-wrap").width() / jQuery(".subscription-block").width();
    // only do stuff if the scale has changed
    if(nNewScale !== nCurrenScale){
        // update tracking var
        nCurrenScale = nNewScale;
        // scale block to match its wrapper
        jQuery(".subscription-block").css({
            transform: "translate(-50%, -50%) " + "scale(" + nNewScale + ")"
        });
    }
}
$(document).ready(function($){
    document.addEventListener("touchstart", function(){}, true);
    jQuery(window).on("load resize orientationchange",function(){
        scaleSubscriptionBlock();
    });
});
